module.exports = __webpack_public_path__ + "static/city-of-melbourne-logo-colour-c2bb05b974be0f1c0e33537cf658c61a.png";